import { useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import SectionHeading from "../SectionHeading";
import { testimonials } from "../../data/siteContent";

export default function TestimonialStrip() {
  const [slide, setSlide] = useState(0);
  const visible = Array.from(
    { length: 3 },
    (_, offset) => testimonials[(slide + offset) % testimonials.length],
  );
  const move = (direction) =>
    setSlide(
      (current) =>
        (current + direction + testimonials.length) % testimonials.length,
    );
  return (
    <>
      <section className="section-space bg-ink text-white">
        <div className="container">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <SectionHeading
              eyebrow="Proof in the experience"
              title="The result is confidence."
              copy="The Bridge is designed around what customers actually need: a local team that owns the details and a clear view of what is happening."
              light
            />
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => move(-1)}
                aria-label="Previous testimonials"
                className="grid h-11 w-11 place-items-center rounded-full border border-white/20 text-white transition hover:border-cyan hover:text-cyan"
              >
                <ArrowLeft size={18} />
              </button>
              <button
                type="button"
                onClick={() => move(1)}
                aria-label="Next testimonials"
                className="grid h-11 w-11 place-items-center rounded-full border border-white/20 text-white transition hover:border-cyan hover:text-cyan"
              >
                <ArrowRight size={18} />
              </button>
            </div>
          </div>
          <div className="mt-12 grid gap-5 md:grid-cols-3">
            {visible.map((item, index) => (
              <Reveal key={`${item.name}-${slide}`} delay={index * 70}>
                <figure className="h-full rounded-3xl border border-white/10 bg-white/[.06] p-6">
                  <div
                    className="flex gap-1 text-bridge"
                    aria-label="5 out of 5 stars"
                  >
                    ★★★★★
                  </div>
                  <blockquote className="mt-6 text-base leading-7 text-slate-200">
                    “{item.quote}”
                  </blockquote>
                  <figcaption className="mt-7 flex items-center gap-3">
                    <span className="grid h-10 w-10 place-items-center rounded-full bg-ocean/20 text-xs font-bold text-cyan">
                      {item.initials}
                    </span>
                    <span>
                      <strong className="block text-sm">{item.name}</strong>
                      <small className="text-slate-400">{item.role}</small>
                    </span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>
          <div
            className="mt-6 flex justify-center gap-2"
            aria-label="Testimonial slides"
          >
            {testimonials.map((item, index) => (
              <button
                key={item.name}
                type="button"
                onClick={() => setSlide(index)}
                aria-label={`Show testimonial ${index + 1}`}
                className={`h-1.5 rounded-full transition-all ${index === slide ? "w-8 bg-cyan" : "w-2 bg-white/30 hover:bg-white/70"}`}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
